import React from "react";
import Form from 'react-bootstrap/Form';
import {InputGroup} from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { faSort } from '@fortawesome/free-solid-svg-icons'

export default function SortBar(props) {
    return (
        <>
            <InputGroup className="mb-3">
                <span className="input-group-text"><FontAwesomeIcon icon={faSort} /></span>
                <Form.Select aria-label="Sorting">
                    <option value="1">Newest</option>
                    <option value="2">Oldest</option>
                    <option value="3">A-Z</option>
                    <option value="4">Z-A</option>
                </Form.Select>
            </InputGroup>

        </>
    );
}



